module.exports = __webpack_public_path__ + "static/media/background.760bd247.png";